
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M491.243 318.27h-89.946V172.973c0-80.117-65.179-145.297-145.297-145.297s-145.297 65.18-145.297 145.297V318.27H20.757C9.294 318.27 0 327.564 0 339.027s9.294 20.757 20.757 20.757h6.919v103.784c0 11.463 9.294 20.757 20.757 20.757h415.135c11.463 0 20.757-9.294 20.757-20.757V359.784h6.919c11.463 0 20.757-9.294 20.757-20.757s-9.294-20.757-20.758-20.757zm-380.54 124.541H69.189v-83.027h41.513v83.027zm124.54-371.534v101.696h-83.027c0-50.119 35.713-92.052 83.027-101.696zm-83.027 143.209h83.027V318.27h-83.027V214.486zm41.514 228.325h-41.513v-83.027h41.513v83.027zm83.027 0h-41.514v-83.027h41.514v83.027zm83.027 0H318.27v-83.027h41.514v83.027zm0-124.541h-83.027V214.486h83.027V318.27zm-83.027-145.297V71.277c47.314 9.644 83.027 51.576 83.027 101.696h-83.027zm166.054 269.838h-41.514v-83.027h41.514v83.027z"}})])
          )
        }
      }
    